import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress"
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import {WithStyles} from "@material-ui/core/styles/withStyles";

import * as moment from 'moment';
import * as Numbered from "numbered";
import * as React from "react";

import {Text} from "../components";
import API, {Supporter} from "../components/API";

import {COFFEE_PRICE} from "./CoffeeCheckout";
import CoffeeIconSmall from "./CoffeeIconSmall";

type ClassNames = "container" | "card" | "supporter" | "content" | "icon" | "quote";

const formatName = (name: string) => name.trim() === "" ? "Someone" : name.trim();
const formatAmount = (amount: number) => {
  const coffees = amount / COFFEE_PRICE / 100;
  return `${coffees > 1 ? Numbered.stringify(coffees) : "a" } coffee${coffees > 1 ? "s" : ""}`
}
const formatTimestamp = (timestamp: number) => {
  return moment(timestamp).fromNow();
};

const styles = (theme: Theme): StyleRules<ClassNames> => ({
  container: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing.unit * 2
  },
  card: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },
  supporter: {
    display: "flex"
  },
  icon: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingRight: theme.spacing.unit * 2
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  quote: {
    fontStyle: "italic"
  }
});

interface IActivityProps extends WithStyles<typeof styles>  {}
interface IActivityState {
  supporters: Supporter[] | null;
}

class Activity extends React.PureComponent<IActivityProps, IActivityState> {

  public state: IActivityState = {
    supporters: null
  };

  public async componentWillMount() {
    const supporters = await API.supporters();
    this.setState({ supporters });
  }

  public render() {
    const {classes} = this.props;
    const {supporters} = this.state;
    if (supporters === null) {
      return (
        <div className={classes.container}> 
          <CircularProgress />
        </div>
      );
    }
    return (
      <>
      {
        supporters.map((supporter: Supporter, key: number) => (
          <Card className={classes.card} {...{key}}>
            <CardContent className={classes.supporter}>
              <div className={classes.icon}>
                <CoffeeIconSmall />
              </div>
              <div className={classes.content}>
                <Text variant="important" gutterBottom={false}>
                  {formatName(supporter.name)} bought {formatAmount(supporter.amount)}
                </Text>
                <Text gutterBottom={supporter.message.trim() !== ""} variant="footnote">
                  {formatTimestamp(supporter.timestamp)}
                </Text>
                {
                  supporter.message.trim() !== "" && (
                    <Text gutterBottom={false}>
                      <span className={classes.quote}>“{supporter.message.trim()}”</span>
                    </Text>
                  )
                }
              </div>
            </CardContent>
          </Card>
        ))
      }
      </>
    );
  }
}

export default withStyles(styles)(Activity);


// WEBPACK FOOTER //
// ./src/buy-me-a-coffee/Activity.tsx